import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import ThemeConfig from './ThemeConfig.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{ /* algorithm: theme.darkAlgorithm,  */...JSON.parse(JSON.stringify(ThemeConfig)) }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
